import { Icon16Like, Icon16LikeOutline, Icon20Like, Icon20LikeOutline } from '@vkontakte/icons';
import classNames from 'clsx';
import React, { type MouseEventHandler, type ReactElement, memo } from 'react';
import type { EViewMode } from 'reactApp/modules/settings/settings.types';
import { DataListControl } from 'reactApp/ui/DataListControl/DataListControl';
import { Hint } from 'reactApp/ui/Hint/Hint';

import type { IconsSizeMap } from '../DataListItemCommonComponents.types';
import styles from './Favorite.css';

interface FavoriteProps {
    className?: string;
    isFavorite?: boolean;
    isAvailable?: boolean;
    animate?: boolean;
    onClick?: MouseEventHandler<HTMLDivElement>;
    viewType: EViewMode;
    size?: number;
}

const ICONS_SIZE_MAP: IconsSizeMap<{ active: ReactElement; disabled: ReactElement }> = {
    16: { active: <Icon16Like />, disabled: <Icon16LikeOutline /> },
    20: { active: <Icon20Like />, disabled: <Icon20LikeOutline /> },
};

export const Favorite = memo<FavoriteProps>(function Favorite({
    isFavorite = false,
    isAvailable = true,
    animate = false,
    onClick,
    className,
    viewType,
    size = 20,
}) {
    if (!isAvailable) {
        return null;
    }

    const { active, disabled } = ICONS_SIZE_MAP[size];

    return (
        <Hint text={isFavorite ? 'Убрать из избранных' : 'Добавить в избранные'}>
            <DataListControl.New
                id="favorite-icon"
                type="favorite"
                viewType={viewType}
                animate={animate}
                className={classNames(styles.root, className, {
                    [styles.favorite]: isFavorite,
                })}
                onClick={onClick}
            >
                {isFavorite ? active : disabled}
            </DataListControl.New>
        </Hint>
    );
});
